// DEPENDENCIES
//// Local
import { ILoggedInUser } from "../../models"
import { IRule } from "../../models/rule.interface"


const RULE_TEMPLATES_KEY: string = "rule_templates";


export function loadRuleTemplates(user: ILoggedInUser): IRule[] {
  const storedRuleTemplates = localStorage.getItem(`${user?.id.slice(0, 6)}_${RULE_TEMPLATES_KEY}`);
  if (storedRuleTemplates == null) return [];
  return JSON.parse(storedRuleTemplates) as IRule[];
}

export function storeRuleTemplate(user: ILoggedInUser, rule: IRule) {
  const ruleToStore: IRule = {
    ...rule,
    rule_tree: JSON.stringify(rule.rule_tree),
  };
  const existingRules: IRule[] | undefined = loadRuleTemplates(user);

  let ruleTemplatesToStore: IRule[] = [...existingRules, ruleToStore];
  ruleTemplatesToStore = ruleTemplatesToStore.sort((a, b) => a.name.localeCompare(b.name));
  localStorage.setItem(`${user.id.slice(0, 6)}_${RULE_TEMPLATES_KEY}`, JSON.stringify(ruleTemplatesToStore));
}

export function deleteRuleTemplate(user: ILoggedInUser, rule: IRule) {
  const existingRules: IRule[] | undefined = loadRuleTemplates(user);
  if (existingRules == null) return;
  let ruleTemplatesToStore: IRule[] = existingRules.filter(r => r.name !== rule.name);
  ruleTemplatesToStore = ruleTemplatesToStore.sort((a, b) => a.name.localeCompare(b.name));
  localStorage.setItem(`${user.id.slice(0, 6)}_${RULE_TEMPLATES_KEY}`, JSON.stringify(ruleTemplatesToStore));
}
